<div  class="p-5 flex flex-column justify-content-center align-items-center
md:justify-content-center md:align-items-center">
  <button (click)="dataToDisplay()" type="button" class="hover:shadow-5 transition-all transition-duration-300	border-1 border-round-sm border-solid border-primary w-6rem h-6rem text-primary bg-white cursor-pointer capitalize text-base">
    {{buttonLabel}}
  </button>
<p class="text-center m-2 font-semibold">{{buttonExplanation}}</p>
</div>

